import $ from 'jquery';

// Profile Cards block — AJAX Load More for pwest_provider cards.
// Scoped per block instance so multiple blocks on one page don't collide.
export default function profileCardsLoadMore() {
  $('[data-profile-cards]').each(function () {
    const $block = $(this);
    const $grid = $block.find('.block-profile-cards__grid');
    const $button = $block.find('.profile-cards__load-more');

    if (!$grid.length || !$button.length) return;

    $button.on('click', function () {
      if ($button.hasClass('is-loading')) return;

      $button.addClass('is-loading').prop('disabled', true);

      const body = new URLSearchParams({
        action: 'pwest_load_more_providers',
        nonce: $block.data('nonce'),
        offset: $button.attr('data-offset'),
      });

      fetch(window.wpData?.ajaxUrl || '/wp-admin/admin-ajax.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body.toString(),
      })
        .then((res) => {
          if (!res.ok) throw new Error(`HTTP ${res.status}`);
          return res.json();
        })
        .then((res) => {
          if (!res.success) throw new Error('pwest_load_more_providers returned an error');

          $grid.append(res.data.html);

          const nextOffset = parseInt($button.attr('data-offset'), 10) + 3;
          $button.attr('data-offset', nextOffset);

          if (res.data.has_more) {
            $button.removeClass('is-loading').prop('disabled', false);
          } else {
            $button.closest('.block-profile-cards__more').remove();
          }
        })
        .catch((err) => {
          console.error('Profile Cards Load More failed:', err);
          $button.removeClass('is-loading').prop('disabled', false);
        });
    });
  });
}
